import React from 'react'

const SrcCardListSkeleton = () => {
  return (
    <div
      className="src-skeleton"
      aria-hidden="true"
      style={{ padding: '20px 30px' }}
    >
      <div className="src-skeleton-header">
        <div className="src-skeleton-badges">
          <div className="src-skeleton-badge" />
          <div className="src-skeleton-badge" />
          <div className="src-skeleton-badge" />
        </div>
        <div className="src-skeleton-close" />
      </div>

      <div className="src-skeleton-item">
        <div className="src-skeleton-radio" />
        <div className="src-skeleton-avatar" />
        <div className="src-skeleton-lines">
          <div className="src-skeleton-line long" />
          <div className="src-skeleton-line short" />
        </div>
      </div>

      <div className="src-skeleton-separator" />

      <div className="src-skeleton-item">
        <div className="src-skeleton-radio" />
        <div className="src-skeleton-lines" style={{ marginLeft: 8 }}>
          <div className="src-skeleton-line medium" />
        </div>
      </div>
    </div>
  )
}

export default SrcCardListSkeleton
